<template>
  <BaseSlideOverModal
    v-model:is-modal-open="localIsOpen"
    :title="userName"
    width="xl"
    @close="localIsOpen = false"
  >
    <template #body>
      <div class="flex w-full flex-col overflow-y-auto">
        <AvailabilityItemManagement
          v-if="loaded"
          :id="userId"
          target="user"
          :edit-mode="true"
        />
      </div>
    </template>
  </BaseSlideOverModal>
</template>

<script>
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import AvailabilityItemManagement from '@/views/settings/unavailability-item/forms/unavailabilityItem/AvailabilityItemManagement.vue'

export default {
  name: 'UserUnavailabilityModal',
  components: { BaseSlideOverModal, AvailabilityItemManagement },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    userName: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'update:isOpen'],
  data() {
    return {
      loaded: false
    }
  },
  computed: {
    localIsOpen: {
      get() {
        return this.isOpen
      },
      set(value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  watch: {
    isOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loaded = true
      }
    }
  }
}
</script>
